// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type PhoneNumber, PhoneNumberDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreatePhoneNumber(): (
  requestBody: PhoneNumberDaten
) => Promise<PhoneNumber> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).phonenumbers.createPhoneNumber({ requestBody }),
    [getAPI]
  );
}
